function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoStepReviewStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1317,
    height: 79.51,
    viewBox: "0 0 1317 79.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.51,
    width: 1317,
    height: 79,
    style: {
      fill: "#fff",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.39 79.07 0.14 79.07 26.94 39.53 0.14 0 245.39 0 272.19 39.53 245.39 79.07",
    style: {
      fill: "#e06b30"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.77,49.84A9.8,9.8,0,0,1,81,58q-3.75,3-10.37,3a24.8,24.8,0,0,1-10.82-2V53a29.39,29.39,0,0,0,5.67,2,23.91,23.91,0,0,0,5.58.72c2.52,0,4.39-.48,5.58-1.44a4.71,4.71,0,0,0,1.8-3.86,4.84,4.84,0,0,0-1.65-3.71c-1.1-1-3.38-2.21-6.82-3.6a18.56,18.56,0,0,1-7.52-5,10.47,10.47,0,0,1-2.18-6.66,9.33,9.33,0,0,1,3.44-7.7q3.42-2.8,9.3-2.8a27.19,27.19,0,0,1,11.12,2.4l-2,5.19a24.39,24.39,0,0,0-9.28-2.18,7.12,7.12,0,0,0-4.72,1.35,4.44,4.44,0,0,0-1.6,3.55,5.12,5.12,0,0,0,.64,2.6,6.41,6.41,0,0,0,2.11,2,35.54,35.54,0,0,0,5.28,2.53,29.37,29.37,0,0,1,6.29,3.33,10.09,10.09,0,0,1,2.93,3.49A10.56,10.56,0,0,1,84.77,49.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.77,60.42H99.4V26.92H87.94V21.46h29.29v5.46H105.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,60.42h-22v-39h22V26.8H129.57V37.45h14.68v5.33H129.57V55.05h15.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.46,33.24q0,6.09-4,9.35t-11.38,3.25H160V60.42h-6.37v-39h11.22q7.31,0,10.94,3T179.46,33.24ZM160,40.48h3.38c3.27,0,5.67-.56,7.2-1.7a6.18,6.18,0,0,0,2.29-5.33,6,6,0,0,0-2-5c-1.37-1.1-3.51-1.65-6.4-1.65h-4.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.06,60.42H210.8V35.26q0-4.5.21-7.14c-.41.42-.91.9-1.5,1.41s-2.59,2.15-6,4.9l-3.14-4,11.46-9h5.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "506.72 79.07 261.47 79.07 288.28 39.53 261.47 0 506.72 0 533.53 39.53 506.72 79.07",
    style: {
      fill: "#e06b30"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(301.24 59.82)",
    style: {
      fontSize: "54.721099853515625px",
      fill: "#fff",
      fontFamily: "OpenSans-SemiBold, Open Sans",
      fontWeight: 600
    }
  }, "REVIEW"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoStepReviewStep);
export default __webpack_public_path__ + "static/media/two-step-review-step.2b019c67c8fcb47996882433a3aac512.svg";
export { ForwardRef as ReactComponent };